(() => {
  const WIDGET_SELECTOR = '.rebuy-bundle-builder';
  const SELECT_SELECTOR = '.rebuy-bundle-builder .rebuy-product-options select.rebuy-select';
  const ROW_SELECTOR = '.product__info .rebuy-bundle-builder .rebuy-product-block';
  const MEDIA_SELECTOR = ROW_SELECTOR + ' .rebuy-product-media';
  const ROW_CONTROLS = 'a, select, .rebuy-product-options, .rebuy-bundle-builder__item-quantity-widget, button.rebuy-button';
  const ZOOM_QUERY = '(hover: hover) and (pointer: fine)';
  const STRIP_SELECTOR = '.rebuy-product-grid.rebuy-bundle-builder__step-body';
  const LAYOUT_CLASS = 'rbb-layout-h';
  const LAYOUT_PARAM = 'rbb_layout';
  const GROUP_CLASS = 'rbb-variant-buttons';
  const BUTTON_CLASS = 'rbb-variant-button';
  const BADGES_CLASS = 'rbb-badges';
  const MAX_BUTTONS = 8;
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const TYPE_MS = 22;
  const TYPE_DELAY = 900;
  const TYPE_PAUSE = { '.': 260, '!': 260, '?': 260, '–': 220, '—': 220, ':': 160, ',': 110 };
  const COUNT_MS = 700;

  const TEXT = {
    start: (count, value) => `Ab ${count} Teilen sparst du ${value}.`,
    next: (remaining, value) => `Noch ${remaining} ${remaining === 1 ? 'Teil' : 'Teile'} bis ${value}.`,
    current: (value) => `Du sparst ${value}`,
    complete: (savings) => (savings ? `Set komplett – du sparst ${savings}.` : 'Set komplett.'),
    completeInline: (value) => `Set komplett – ${value} gesichert.`,
    savings: 'Du sparst',
    percentOff: (percent) => `−${percent} %`,
    addAll: (count) => `Alle ${count} Teile`,
    addRest: (count) => (count === 1 ? 'Restliches Teil' : `Restliche ${count} Teile`),
    addAllSub: (value) => (value ? `${value} sparen` : 'in den Warenkorb'),
    addAllDone: 'im Warenkorb ✓',
    addAllBusy: 'Wird hinzugefügt…',
    added: 'Dein Set liegt im Warenkorb.',
    addedTier: (value) => `Dein Set liegt im Warenkorb – ${value} gesichert.`,
    inCart: (variant) => (variant ? `Im Warenkorb · ${variant}` : 'Im Warenkorb'),
    rowInCart: (title) => (title ? `${title} liegt im Warenkorb – Warenkorb öffnen` : 'Liegt im Warenkorb – Warenkorb öffnen'),
    rowAdd: (title) => (title ? `${title} zum Set hinzufügen` : 'Zum Set hinzufügen'),
    rowRemove: (title) => (title ? `${title} aus dem Set entfernen` : 'Aus dem Set entfernen'),
    toggleAdd: 'Zum Set hinzufügen',
    toggleSelected: 'Im Set',
    toggleInCart: 'Im Warenkorb',
    stripPrev: 'Vorherige Produkte',
    stripNext: 'Weitere Produkte'
  };

  const STAR = '<svg viewBox="0 0 24 24" class="icon" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.6 9.3l6.5-.9z"/></svg>';
  const CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';

  const ADDED_NOTE_MS = 6000;
  const CART_ADD_TIMEOUT = 8000;
  const productCache = new Map();
  const widgetsWatched = new WeakSet();
  let primed = false;
  let pendingCartAdd = null;
  let cartRequest = null;

  function inlineHost(node) {
    return node.closest('.product__info');
  }

  function productHandle(node) {
    const block = node.closest('.rebuy-product-block');
    const link = block && block.querySelector('a[href*="/products/"]');
    if (!link) return null;
    try {
      const path = new URL(link.href, window.location.origin).pathname;
      const match = path.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    const request = fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}?view=chips`, {
      headers: { Accept: 'text/html' }
    })
      .then((response) => (response.ok ? response.text() : null))
      .then((text) => {
        if (!text) return null;
        const data = JSON.parse(text.trim());
        const states = new Map();
        data.variants.forEach((variant) => states.set(String(variant.id), variant.state));
        return {
          states,
          rating: data.rating_value || '',
          ratingCount: data.rating_count || '',
          badges: (data.rating || '') + (data.badges || '')
        };
      })
      .catch(() => null);

    productCache.set(handle, request);
    return request;
  }

  function paintAvailability(select, group) {
    const handle = productHandle(select);
    if (!handle) return;

    fetchProduct(handle).then((data) => {
      if (!data || !group.isConnected) return;
      group.querySelectorAll('.' + BUTTON_CLASS).forEach((button) => {
        const state = data.states.get(button.dataset.value);
        if (!state) return;
        button.classList.remove('is-now', 'is-order', 'is-sold');
        button.classList.add('is-' + state);
      });
      group.classList.add('has-availability');
    });
  }

  function syncGroup(select, group) {
    group.querySelectorAll('.' + BUTTON_CLASS).forEach((button) => {
      const active = button.dataset.value === select.value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function shortLabel(label) {
    const match = label.match(/^(.{1,12}?)\s+[-–(]/);
    if (!match) return null;
    const short = match[1].trim();
    return short && short !== label ? short : null;
  }

  function buildGroup(select) {
    const group = document.createElement('div');
    group.className = GROUP_CLASS;
    group.setAttribute('role', 'group');

    const label = select.getAttribute('aria-label');
    if (label) group.setAttribute('aria-label', label);

    Array.from(select.options).forEach((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = BUTTON_CLASS;
      button.dataset.value = option.value;
      button.disabled = option.disabled;

      const full = option.textContent.trim();
      const short = shortLabel(full);
      if (short) {
        const fullSpan = document.createElement('span');
        fullSpan.className = BUTTON_CLASS + '__full';
        fullSpan.textContent = full;
        const shortSpan = document.createElement('span');
        shortSpan.className = BUTTON_CLASS + '__short';
        shortSpan.textContent = short;
        button.classList.add('has-short');
        button.append(fullSpan, shortSpan);
      } else {
        button.textContent = full;
      }

      button.addEventListener('click', () => {
        if (select.value === option.value) return;
        const apply = () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncGroup(select, group);
        };
        const block = select.closest('.rebuy-product-block');
        if (block && inlineHost(block)) {
          if (isSelected(block)) {
            swapVariant(block, apply);
          } else {
            apply();
            nudgeRow(block);
          }
          return;
        }
        apply();
      });

      group.appendChild(button);
    });

    return group;
  }

  function hasNativeSwatches(select) {
    const options = select.closest('.rebuy-product-options');
    return !!(options && options.querySelector('.rebuy-product-options__button-swatches-container:not(.rebuy-style__hidden-block)'));
  }

  function enhance(select) {
    if (select.dataset.rbbEnhanced) return;
    if (!select.options || select.options.length < 2) return;

    if (select.options.length > MAX_BUTTONS || hasNativeSwatches(select)) {
      select.dataset.rbbEnhanced = 'skipped';
      select.classList.add('rbb-select-kept');
      return;
    }

    select.dataset.rbbEnhanced = 'true';

    const group = buildGroup(select);
    select.insertAdjacentElement('afterend', group);
    select.classList.add('rbb-select-replaced');
    syncGroup(select, group);
    paintAvailability(select, group);

    select.addEventListener('change', () => syncGroup(select, group));
  }

  function mediaTarget(block) {
    return block.querySelector('.rebuy-product-media');
  }

  function decorateRow(block) {
    const title = block.querySelector('.rebuy-product-info .rebuy-product-title');
    if (!title) return;

    const link = title.querySelector('a.rebuy-product-title');
    if (link && link.target !== '_blank') {
      link.target = '_blank';
      link.rel = 'noopener nofollow';
    }

    const imageLink = block.querySelector('.rebuy-product-media a.rebuy-product-image');
    if (imageLink && imageLink.tabIndex !== -1) {
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
    }

    if (title.dataset.rbbDecorated) return;

    const handle = productHandle(block);
    if (!handle) return;

    title.dataset.rbbDecorated = 'pending';

    fetchProduct(handle).then((data) => {
      if (!title.isConnected) return;
      if (!data) {
        title.dataset.rbbDecorated = 'empty';
        return;
      }

      if (data.rating && !title.querySelector('.rbb-row-rating')) {
        const rating = document.createElement('span');
        rating.className = 'rbb-row-rating';
        rating.innerHTML = STAR + data.rating + (data.ratingCount ? ' (' + data.ratingCount + ')' : '');
        title.appendChild(rating);
      }

      const media = block.querySelector('.rebuy-product-media');
      const chip = materialChip(data.badges);
      if (chip && media && !media.querySelector('.rbb-row-material')) media.appendChild(chip);

      title.dataset.rbbDecorated = 'true';
    });
  }

  function materialChip(html) {
    if (!html) return null;
    const holder = document.createElement('template');
    holder.innerHTML = html;
    const chip = holder.content.querySelector('.material-chip');
    if (!chip) return null;
    chip.classList.remove('material-chip--overlay', 'absolute', 'z-2', 'pointer-events-none');
    chip.classList.add('rbb-row-material');
    return chip;
  }

  function setText(node, text) {
    if (node.firstChild && node.firstChild.nodeType === 3 && node.childNodes.length === 1) {
      if (node.firstChild.data !== text) node.firstChild.data = text;
      return;
    }
    node.textContent = text;
  }

  function flash(node, className) {
    if (!primed || REDUCED_MOTION.matches) return;
    node.classList.remove(className);
    void node.offsetWidth;
    node.classList.add(className);
  }

  function paintRowSavings(block) {
    const price = block.querySelector('.rebuy-product-price');
    if (!price) return;

    const compareNode = price.querySelector('.rebuy-money.compare-at');
    const sale = parseMoney(price.querySelector('.rebuy-money.sale'));
    const compare = parseMoney(compareNode);
    const percent = sale !== null && compare !== null && compare > sale ? Math.round((1 - sale / compare) * 100) : 0;
    let tag = price.querySelector('.rbb-row-save');

    if (percent < 1 || !compareNode) {
      if (tag) tag.remove();
      return;
    }

    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'rbb-row-save';
      compareNode.parentNode.appendChild(tag);
    }

    const text = TEXT.percentOff(percent);
    if (tag.textContent !== text) {
      setText(tag, text);
      flash(tag, 'is-changed');
    }
  }

  function decorate(block) {
    if (inlineHost(block)) {
      decorateRow(block);
      paintRowSavings(block);
      return;
    }

    const target = mediaTarget(block);
    if (!target || target.dataset.rbbDecorated) return;

    const handle = productHandle(block);
    if (!handle) return;

    target.dataset.rbbDecorated = 'pending';

    fetchProduct(handle).then((data) => {
      if (!target.isConnected) return;
      if (!data || !data.badges) {
        target.dataset.rbbDecorated = 'empty';
        return;
      }

      if (!target.querySelector('.' + BADGES_CLASS)) {
        const wrap = document.createElement('div');
        wrap.className = BADGES_CLASS;
        wrap.innerHTML = data.badges;
        target.appendChild(wrap);
      }

      target.dataset.rbbDecorated = 'true';
    });
  }

  function watchPanel(widget) {
    if (widget.dataset.rbbPanelWatched || inlineHost(widget)) return;
    const main = widget.querySelector('.rebuy-bundle-builder__main');
    if (!main) return;
    widget.dataset.rbbPanelWatched = 'true';

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        widget.classList.toggle('rbb-panel-hidden', !entry.isIntersecting);
      });
    }, { rootMargin: '-96px 0px -140px 0px', threshold: 0 });

    observer.observe(main);
  }

  function parseMoney(node) {
    if (!node) return null;
    const text = node.textContent.replace(/[^\d,.\-]/g, '');
    if (!text) return null;
    const normalized = text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text;
    const value = parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function formatMoney(value) {
    return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function readTiers(widget) {
    return Array.from(widget.querySelectorAll('.rebuy-bundle-builder__progress-step')).map((step, index) => {
      const label = step.querySelector('.rebuy-bundle-builder__progress-step-label');
      const value = step.querySelector('.rebuy-bundle-builder__progress-step-value');
      const number = label && label.textContent.match(/\d+/);
      return {
        step,
        count: number ? parseInt(number[0], 10) : index + 2,
        value: value ? value.textContent.trim() : '',
        complete: step.classList.contains('complete')
      };
    });
  }

  function tidyPercent(value) {
    return value.replace(/(\d)\s*%/, '$1 %');
  }

  function cartMode(widget) {
    return !!inlineHost(widget) && selectedCount(widget) === 0 && inCartCount(widget) > 0;
  }

  function cartItems(widget) {
    return parseInt(widget.dataset.rbbCartItems || '0', 10) || 0;
  }

  function effectiveCount(widget) {
    const count = selectedCount(widget);
    return count > 0 ? count : (cartMode(widget) ? cartItems(widget) : 0);
  }

  function progressMessage(widget) {
    const inline = !!inlineHost(widget);
    const countNode = widget.querySelector('.rebuy-bundle-builder__group-container-header-products_count');
    const count = countNode ? parseInt(countNode.textContent, 10) || 0 : 0;
    const tiers = readTiers(widget).filter((tier) => tier.value);
    if (!tiers.length) return null;

    const label = (tier) => (inline ? tidyPercent(tier.value) : tier.value);
    const next = tiers.find((tier) => tier.count > count);
    const current = tiers.filter((tier) => tier.count <= count).pop();

    if (count === 0 && cartMode(widget)) {
      const reached = tiers.filter((tier) => tier.count <= cartItems(widget)).pop();
      return { text: reached ? TEXT.addedTier(label(reached)) : TEXT.added, state: 'added' };
    }
    if (count === 0 && inline && addedActive(widget)) return { text: TEXT.added, state: 'added' };
    if (count === 0) return { text: TEXT.start(tiers[0].count, label(tiers[0])), state: 'start' };

    if (next) {
      const remaining = next.count - count;
      const parts = [];
      if (current && !inline) parts.push(TEXT.current(label(current)));
      parts.push(TEXT.next(remaining, label(next)));
      return { text: parts.join(' · '), state: current ? 'progress' : 'start' };
    }

    if (inline && current) return { text: TEXT.completeInline(label(current)), state: 'complete' };

    const cta = widget.querySelector('.rebuy-bundle-builder__cta-container');
    const compare = parseMoney(cta && cta.querySelector('.rebuy-money.compare-at'));
    const sale = parseMoney(cta && cta.querySelector('.rebuy-money.sale'));
    const savings = compare !== null && sale !== null && compare > sale ? formatMoney(compare - sale) : (current ? current.value : '');
    return { text: TEXT.complete(savings), state: 'complete' };
  }

  function countUp(node, from, to) {
    if (node.rbbFrame) window.cancelAnimationFrame(node.rbbFrame);
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min(1, (now - start) / COUNT_MS);
      const eased = 1 - Math.pow(1 - progress, 3);
      setText(node, formatMoney(from + (to - from) * eased));
      node.rbbFrame = progress < 1 ? window.requestAnimationFrame(tick) : null;
    };
    node.rbbFrame = window.requestAnimationFrame(tick);
  }

  function paintSavings(widget) {
    if (!inlineHost(widget)) return;
    const bar = widget.querySelector('.rebuy-bundle-builder__group-container-progress-bar');
    const action = widget.querySelector('.rebuy-bundle-builder__group-container-action');
    const anchor = bar || action;
    if (!anchor) return;

    const cta = widget.querySelector('.rebuy-bundle-builder__cta-container');
    let compare = parseMoney(cta && cta.querySelector('.rebuy-money.compare-at'));
    const sale = parseMoney(cta && cta.querySelector('.rebuy-money.sale'));
    let savings = compare !== null && sale !== null && compare > sale ? compare - sale : 0;

    if (savings <= 0 && cartMode(widget)) {
      if (widget.dataset.rbbCartSavings === undefined) return;
      compare = (parseInt(widget.dataset.rbbCartOriginal || '0', 10) || 0) / 100;
      savings = (parseInt(widget.dataset.rbbCartSavings || '0', 10) || 0) / 100;
    }

    let box = anchor.parentNode.querySelector(':scope > .rbb-savings');

    if (savings <= 0) {
      if (box && !box.hidden) {
        box.hidden = true;
        box.dataset.rbbValue = '0';
      }
      return;
    }

    if (!box) {
      box = document.createElement('p');
      box.className = 'rbb-savings';
      box.setAttribute('aria-live', 'polite');
      const label = document.createElement('span');
      label.className = 'rbb-savings__label';
      label.textContent = TEXT.savings;
      const value = document.createElement('strong');
      value.className = 'rbb-savings__value';
      value.textContent = formatMoney(0);
      const pct = document.createElement('span');
      pct.className = 'rbb-savings__pct';
      box.append(label, ' ', value, ' ', pct);
      box.hidden = true;
      if (bar) bar.insertAdjacentElement('afterend', box);
      else action.insertAdjacentElement('beforebegin', box);
    }

    const wasHidden = box.hidden;
    const previous = parseFloat(box.dataset.rbbValue || '0') || 0;
    const value = box.querySelector('.rbb-savings__value');
    const pct = box.querySelector('.rbb-savings__pct');

    if (wasHidden) box.hidden = false;
    setText(pct, TEXT.percentOff(Math.round((savings / compare) * 100)));

    if (!wasHidden && Math.abs(previous - savings) < 0.005) return;
    box.dataset.rbbValue = String(savings);

    if (!primed || REDUCED_MOTION.matches) {
      setText(value, formatMoney(savings));
      return;
    }

    countUp(value, wasHidden ? 0 : previous, savings);
    flash(box, 'is-changed');
  }

  function stepPositions(count) {
    if (count <= 1) return [100];
    if (count === 2) return [30, 100];
    if (count === 3) return [24, 62, 100];
    if (count === 4) return [22, 48, 74, 100];
    return Array.from({ length: count }, (_, index) => 22 + (index * 78) / (count - 1));
  }

  function paintFill(widget, bar) {
    const tiers = readTiers(widget);
    if (!tiers.length) return;

    const count = effectiveCount(widget);
    const positions = stepPositions(tiers.length);
    const points = [{ count: 0, position: 0 }].concat(tiers.map((tier, index) => ({ count: tier.count, position: positions[index] })));

    let fill = 100;
    for (let index = 1; index < points.length; index += 1) {
      const from = points[index - 1];
      const to = points[index];
      if (count <= to.count) {
        const span = Math.max(to.count - from.count, 1);
        fill = from.position + ((count - from.count) / span) * (to.position - from.position);
        break;
      }
    }

    bar.style.setProperty('--rbb-fill', Math.max(0, Math.min(100, fill)).toFixed(2) + '%');
  }

  function paintProgress(widget) {
    const bar = widget.querySelector('.rebuy-bundle-builder__group-container-progress-bar');
    if (!bar) return;

    paintFill(widget, bar);

    const message = progressMessage(widget);
    let note = bar.parentNode.querySelector(':scope > .rbb-progress-note');
    if (!message) {
      if (note) note.remove();
      return;
    }

    if (!note) {
      note = document.createElement('p');
      note.className = 'rbb-progress-note';
      note.setAttribute('aria-live', 'polite');
      const savings = bar.parentNode.querySelector(':scope > .rbb-savings');
      (savings || bar).insertAdjacentElement('afterend', note);
    }

    if (note.textContent !== message.text) {
      note.textContent = message.text;
      note.dataset.state = message.state;
      if (primed && !REDUCED_MOTION.matches) {
        note.classList.remove('is-changed');
        void note.offsetWidth;
        note.classList.add('is-changed');
      }
    }

    const inCart = cartMode(widget);
    const reached = inCart ? cartItems(widget) : 0;
    readTiers(widget).forEach((tier) => {
      const wasComplete = tier.step.dataset.rbbComplete === 'true';
      tier.step.dataset.rbbComplete = tier.complete ? 'true' : 'false';
      if (tier.complete && !wasComplete && primed && !REDUCED_MOTION.matches) {
        tier.step.classList.remove('rbb-pulse');
        void tier.step.offsetWidth;
        tier.step.classList.add('rbb-pulse');
      }
      const cartComplete = inCart && tier.count <= reached;
      if (tier.step.classList.contains('rbb-cart-complete') !== cartComplete) tier.step.classList.toggle('rbb-cart-complete', cartComplete);
    });
  }

  function paintHolders(widget) {
    widget.querySelectorAll('.rebuy-bundle-builder__product-holder').forEach((holder) => {
      const filled = !!holder.querySelector('.rebuy-bundle-builder__product-holder-data');
      const wasFilled = holder.dataset.rbbFilled === 'true';
      holder.dataset.rbbFilled = filled ? 'true' : 'false';
      if (filled && !wasFilled && primed && !REDUCED_MOTION.matches) {
        holder.classList.remove('rbb-just-added');
        void holder.offsetWidth;
        holder.classList.add('rbb-just-added');
      }
    });
  }

  function flyToPanel(button) {
    if (REDUCED_MOTION.matches) return;
    const block = button.closest('.rebuy-product-block');
    const widget = button.closest('.rebuy-bundle-builder');
    if (!block || !widget || inlineHost(widget)) return;

    const image = block.querySelector('.rebuy-product-media img');
    const container = widget.querySelector('.rebuy-bundle-builder__group-container');
    if (!image || !container) return;

    const empty = container.querySelector('.rebuy-bundle-builder__product-holder-template');
    const target = (empty || container.querySelector('.rebuy-bundle-builder__group-container-header') || container).getBoundingClientRect();
    const from = image.getBoundingClientRect();
    if (!from.width || !target.width) return;

    const clone = image.cloneNode(false);
    clone.className = 'rbb-fly';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    document.body.appendChild(clone);

    const size = Math.min(from.width, from.height);
    const dx = target.left + Math.min(target.width, 64) / 2 - (from.left + from.width / 2);
    const dy = target.top + Math.min(target.height, 64) / 2 - (from.top + from.height / 2);
    const scale = Math.max(48 / size, 0.12);

    const animation = clone.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 40}px) scale(${(1 + scale) / 2})`, opacity: 0.95, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.2 }
      ],
      { duration: 620, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }
    );
    animation.onfinish = () => clone.remove();
    animation.oncancel = () => clone.remove();
  }

  function markRowPositions() {
    document.querySelectorAll('.rebuy-bundle-builder__step-body').forEach((grid) => {
      if (inlineHost(grid)) return;
      const blocks = Array.from(grid.querySelectorAll(':scope > .rebuy-product-block'));
      let rowTop = null;
      blocks.forEach((block) => {
        const top = block.offsetTop;
        const startsRow = rowTop === null || Math.abs(top - rowTop) > 4;
        if (startsRow) rowTop = top;
        block.classList.toggle('rbb-plus', !startsRow);
      });
    });
  }

  function textNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node = walker.nextNode();
    while (node) {
      nodes.push({ node, text: node.data });
      node = walker.nextNode();
    }
    return nodes;
  }

  function typeBubble(bubble) {
    const live = bubble.querySelector('.rbb-head__bubble-live');
    if (!live || live.dataset.rbbTyped) return;
    live.dataset.rbbTyped = 'true';

    if (REDUCED_MOTION.matches) {
      live.classList.add('is-typed');
      return;
    }

    const full = live.textContent.trim();
    const nodes = textNodes(live);
    bubble.setAttribute('aria-label', full);
    live.setAttribute('aria-hidden', 'true');
    nodes.forEach((entry) => {
      entry.node.data = '';
    });
    live.classList.add('is-waiting');

    let index = 0;
    let offset = 0;

    const finish = () => {
      live.classList.remove('is-typing');
      live.classList.add('is-typed');
      live.removeAttribute('aria-hidden');
      bubble.removeAttribute('aria-label');
    };

    const step = () => {
      while (index < nodes.length && offset >= nodes[index].text.length) {
        index += 1;
        offset = 0;
      }
      if (index >= nodes.length) {
        finish();
        return;
      }
      const entry = nodes[index];
      const char = entry.text[offset];
      entry.node.data += char;
      offset += 1;
      window.setTimeout(step, TYPE_MS + (TYPE_PAUSE[char] || 0));
    };

    window.setTimeout(() => {
      live.classList.remove('is-waiting');
      live.classList.add('is-typing');
      step();
    }, TYPE_DELAY);
  }

  function watchBubbles() {
    document.querySelectorAll('.product__info.rbb-live .rbb-head__bubble[data-rbb-typewriter]').forEach((bubble) => {
      if (bubble.dataset.rbbObserved) return;
      bubble.dataset.rbbObserved = 'true';

      if (!('IntersectionObserver' in window)) {
        typeBubble(bubble);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          typeBubble(bubble);
          observer.disconnect();
        });
      }, { threshold: 0.5 });
      observer.observe(bubble);
    });
  }

  function syncInline() {
    document.querySelectorAll('.product__info').forEach((info) => {
      const main = info.querySelector('.rebuy-bundle-builder__main');
      const live = !!(main && main.querySelector('.rebuy-product-block'));
      if (info.classList.contains('rbb-live') !== live) info.classList.toggle('rbb-live', live);
      if (!main) return;

      let host = main.closest('.rebuy-bundle-builder') || main;
      while (host.parentElement && host.parentElement !== info) host = host.parentElement;
      if (host.parentElement !== info) return;
      if (host.classList.contains('rbb-inline-host') !== live) host.classList.toggle('rbb-inline-host', live);
      if (!live) return;

      const head = info.querySelector(':scope > .rbb-head');
      if (head && head.nextElementSibling !== host) info.insertBefore(head, host);
    });
    watchBubbles();
  }

  function forcedLayout() {
    try {
      return new URLSearchParams(window.location.search).get(LAYOUT_PARAM);
    } catch (error) {
      return null;
    }
  }

  function horizontalIds() {
    const node = document.querySelector('[data-rbb-horizontal]');
    const raw = node ? node.getAttribute('data-rbb-horizontal') || '' : '';
    return raw.split(/[^0-9]+/).filter(Boolean);
  }

  function isHorizontal(widget) {
    const forced = forcedLayout();
    if (forced === 'h') return true;
    if (forced === 'v') return false;
    const id = widgetId(widget);
    return !!id && horizontalIds().includes(id);
  }

  function paintLayout(widget) {
    const horizontal = isHorizontal(widget);
    if (widget.classList.contains(LAYOUT_CLASS) !== horizontal) widget.classList.toggle(LAYOUT_CLASS, horizontal);
  }

  function stripOf(step) {
    return step.querySelector(STRIP_SELECTOR);
  }

  function paintStrip(widget) {
    const horizontal = widget.classList.contains(LAYOUT_CLASS);
    widget.querySelectorAll('.rebuy-bundle-builder__step-container').forEach((step) => {
      const strip = stripOf(step);
      let nav = step.querySelector(':scope > .rbb-strip-nav');
      if (!horizontal || !strip) {
        if (nav) nav.remove();
        return;
      }

      if (!nav) {
        nav = document.createElement('div');
        nav.className = 'rbb-strip-nav';
        ['prev', 'next'].forEach((direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rbb-strip-arrow rbb-strip-arrow--' + direction;
          button.dataset.rbbDirection = direction;
          button.setAttribute('aria-label', direction === 'prev' ? TEXT.stripPrev : TEXT.stripNext);
          button.innerHTML = CHEVRON;
          nav.appendChild(button);
        });
        step.appendChild(nav);
      }

      if (!strip.dataset.rbbStrip) {
        strip.dataset.rbbStrip = 'true';
        let scrollQueued = false;
        strip.addEventListener('scroll', () => {
          if (scrollQueued) return;
          scrollQueued = true;
          window.requestAnimationFrame(() => {
            scrollQueued = false;
            syncStrip(step);
          });
        }, { passive: true });
      }

      syncStrip(step);
    });
  }

  function syncStrip(step) {
    const strip = stripOf(step);
    const nav = step.querySelector(':scope > .rbb-strip-nav');
    if (!strip || !nav) return;

    const max = strip.scrollWidth - strip.clientWidth;
    const left = strip.scrollLeft;
    const prev = nav.querySelector('.rbb-strip-arrow--prev');
    const next = nav.querySelector('.rbb-strip-arrow--next');
    if (prev && prev.disabled !== left <= 1) prev.disabled = left <= 1;
    if (next && next.disabled !== left >= max - 1) next.disabled = left >= max - 1;
    if (nav.hidden !== max <= 1) nav.hidden = max <= 1;

    const media = strip.querySelector('.rebuy-product-block .rebuy-product-media');
    if (media) {
      const center = media.getBoundingClientRect().top - step.getBoundingClientRect().top + media.offsetHeight / 2;
      const value = Math.round(center) + 'px';
      if (step.style.getPropertyValue('--rbbh-arrow-y') !== value) step.style.setProperty('--rbbh-arrow-y', value);
    }
  }

  function syncStrips() {
    document.querySelectorAll('.' + LAYOUT_CLASS + ' .rebuy-bundle-builder__step-container').forEach(syncStrip);
  }

  function scrollBehavior() {
    return REDUCED_MOTION.matches ? 'auto' : 'smooth';
  }

  function slideStrip(step, direction) {
    const strip = stripOf(step);
    if (!strip) return;
    const block = strip.querySelector('.rebuy-product-block');
    const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
    const distance = block ? block.getBoundingClientRect().width + gap : strip.clientWidth;
    strip.scrollBy({ left: direction * distance, behavior: scrollBehavior() });
  }

  function revealBlock(block) {
    const strip = block.closest(STRIP_SELECTOR);
    const widget = block.closest(WIDGET_SELECTOR);
    if (!strip || !widget || !widget.classList.contains(LAYOUT_CLASS)) return;

    const styles = getComputedStyle(strip);
    const padStart = parseFloat(styles.paddingLeft) || 0;
    const padEnd = parseFloat(styles.paddingRight) || 0;
    const outer = strip.getBoundingClientRect();
    const inner = block.getBoundingClientRect();
    if (inner.left >= outer.left + padStart - 1 && inner.right <= outer.right - padEnd + 1) return;

    strip.scrollBy({ left: inner.left - (outer.left + padStart), behavior: scrollBehavior() });
  }

  function isSelected(block) {
    return !!block.querySelector('.rebuy-bundle-builder__item-quantity-widget');
  }

  function rowTitle(block) {
    const link = block.querySelector('.rebuy-product-info a.rebuy-product-title');
    return link ? link.textContent.trim() : '';
  }

  function paintRows(widget) {
    widget.querySelectorAll('.rebuy-product-block').forEach((block) => {
      const selected = isSelected(block);
      block.classList.toggle('rbb-selected', selected);

      const host = block.querySelector('.rebuy-bundle-builder__step-product');
      if (!host) return;

      let toggle = host.querySelector(':scope > .rbb-row-toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'rbb-row-toggle';
        const text = document.createElement('span');
        text.className = 'rbb-row-toggle__label';
        toggle.appendChild(text);
        host.appendChild(toggle);
      }

      const inCart = !selected && block.classList.contains('rbb-in-cart');
      const pressed = selected ? 'true' : 'false';
      if (toggle.getAttribute('aria-pressed') !== pressed) toggle.setAttribute('aria-pressed', pressed);
      if (toggle.classList.contains('is-in-cart') !== inCart) toggle.classList.toggle('is-in-cart', inCart);

      let label = selected ? TEXT.rowRemove(rowTitle(block)) : TEXT.rowAdd(rowTitle(block));
      if (inCart) label = TEXT.rowInCart(rowTitle(block));
      if (toggle.getAttribute('aria-label') !== label) toggle.setAttribute('aria-label', label);

      const text = toggle.querySelector('.rbb-row-toggle__label');
      if (text) setText(text, selected ? TEXT.toggleSelected : (inCart ? TEXT.toggleInCart : TEXT.toggleAdd));
    });
  }

  function nudgeRow(block) {
    revealBlock(block);
    const toggle = block.querySelector('.rbb-row-toggle');
    if (toggle) flash(toggle, 'rbb-nudge');
  }

  function toggleRow(block) {
    if (block.dataset.rbbBusy) return;
    const widget = block.closest('.rebuy-bundle-builder');
    if (!widget) return;

    revealBlock(block);

    if (block.classList.contains('rbb-in-cart') && !isSelected(block)) {
      openCartDrawer();
      return;
    }

    const control = isSelected(block)
      ? block.querySelector('.rebuy-bundle-builder__item-quantity-widget-button')
      : block.querySelector('button.rebuy-button');
    if (!control || control.disabled) return;

    block.dataset.rbbBusy = 'true';
    const before = selectedCount(widget);
    control.click();
    waitFor(() => selectedCount(widget) !== before, 2500).then(() => {
      delete block.dataset.rbbBusy;
      paintRows(widget);
    });
  }

  async function swapVariant(block, apply) {
    const widget = block.closest('.rebuy-bundle-builder');
    if (!widget || block.dataset.rbbBusy) {
      apply();
      return;
    }

    block.dataset.rbbBusy = 'true';

    const remove = block.querySelector('.rebuy-bundle-builder__item-quantity-widget-button');
    if (remove) {
      const before = selectedCount(widget);
      remove.click();
      await waitFor(() => selectedCount(widget) < before, 2500);
    }

    apply();
    await waitFor(() => !!block.querySelector('button.rebuy-button'), 2500);

    const add = block.querySelector('button.rebuy-button');
    if (add && !add.disabled) {
      const before = selectedCount(widget);
      add.click();
      await waitFor(() => selectedCount(widget) > before, 2500);
    }

    delete block.dataset.rbbBusy;
    paintRows(widget);
  }

  function addedActive(widget) {
    const until = parseInt(widget.dataset.rbbAddedUntil || '0', 10);
    return until > Date.now();
  }

  function markAdded(widget) {
    widget.dataset.rbbAddedUntil = String(Date.now() + ADDED_NOTE_MS);
    paintProgress(widget);
    window.setTimeout(() => {
      if (!addedActive(widget)) paintProgress(widget);
    }, ADDED_NOTE_MS + 100);
  }

  function selectedLines(widget) {
    const lines = new Map();
    widget.querySelectorAll('.rebuy-product-block').forEach((block) => {
      if (!isSelected(block)) return;
      const id = rowProductId(block);
      if (!id) return;
      const variant = block.querySelector('.rebuy-variant-title');
      lines.set(id, { variant: variant ? variant.textContent.trim() : '', quantity: 1 });
    });
    return lines;
  }

  function waitForCartAdd(widget) {
    if (pendingCartAdd) return pendingCartAdd.promise;
    let settle = null;
    const promise = new Promise((resolve) => {
      settle = resolve;
    });
    const timer = window.setTimeout(() => finishCartAdd(false), CART_ADD_TIMEOUT);
    pendingCartAdd = { widget, promise, settle, timer, lines: selectedLines(widget) };
    return promise;
  }

  function finishCartAdd(confirmed) {
    const pending = pendingCartAdd;
    if (!pending) return;
    pendingCartAdd = null;
    window.clearTimeout(pending.timer);
    pending.settle(confirmed);
    if (confirmed) announceCartAdd(pending.widget, pending.lines);
  }

  function fetchCart(force) {
    if (!cartRequest || force) {
      const root = window.Shopify?.routes?.root || '/';
      cartRequest = fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
    }
    return cartRequest;
  }

  function widgetId(widget) {
    const match = (widget.id || '').match(/\d+/);
    if (match) return match[0];
    const host = widget.closest('[data-rebuy-id]');
    return host ? host.getAttribute('data-rebuy-id') || '' : '';
  }

  function rowProductId(block) {
    const name = Array.from(block.classList).find((item) => item.startsWith('product-id-'));
    return name ? name.slice('product-id-'.length) : '';
  }

  function inCartCount(widget) {
    return parseInt(widget.dataset.rbbInCart || '0', 10) || 0;
  }

  function paintCartTags(widget) {
    const lines = widget.rbbCartLines;
    if (!lines) return;

    widget.querySelectorAll('.rebuy-product-block').forEach((block) => {
      const line = lines.get(rowProductId(block));
      if (block.classList.contains('rbb-in-cart') !== !!line) block.classList.toggle('rbb-in-cart', !!line);
      let tag = block.querySelector('.rbb-row-cart');
      if (!line) {
        if (tag) tag.remove();
        return;
      }
      const price = block.querySelector('.rebuy-product-price > div') || block.querySelector('.rebuy-product-price');
      if (!tag && price) {
        tag = document.createElement('span');
        tag.className = 'rbb-row-cart';
        price.appendChild(tag);
      }
      if (tag) setText(tag, TEXT.inCart(shortLabel(line.variant || '') || line.variant));
    });
  }

  function paintCartState(widget, cart) {
    const id = widgetId(widget);
    const lines = new Map();
    let items = 0;
    let original = 0;
    let savings = 0;
    ((cart && cart.items) || []).forEach((item) => {
      const properties = item.properties || {};
      if (!id || String(properties._widget_id) !== String(id)) return;
      const key = String(item.product_id);
      const known = lines.get(key);
      lines.set(key, { variant: item.variant_title || '', quantity: (known ? known.quantity : 0) + (item.quantity || 0) });
      items += item.quantity || 0;
      const lineOriginal = item.original_line_price || 0;
      const lineFinal = typeof item.final_line_price === 'number' ? item.final_line_price : lineOriginal;
      original += lineOriginal;
      savings += Math.max(0, lineOriginal - lineFinal);
    });

    widget.rbbCartLines = lines;
    widget.dataset.rbbInCart = String(lines.size);
    widget.dataset.rbbCartItems = String(items);
    widget.dataset.rbbCartOriginal = String(original);
    widget.dataset.rbbCartSavings = String(savings);
    paintCartTags(widget);
    paintRows(widget);
    paintCartMode(widget);
    paintProgress(widget);
    paintSavings(widget);
    paintAddAll(widget);
  }

  function paintCartMode(widget) {
    const active = cartMode(widget);
    if (widget.classList.contains('rbb-cart-mode') !== active) widget.classList.toggle('rbb-cart-mode', active);
  }

  function syncCartState(force) {
    const widgets = Array.from(document.querySelectorAll('.product__info .rebuy-bundle-builder'));
    if (!widgets.length) return;
    fetchCart(force).then((cart) => {
      widgets.forEach((widget) => {
        if (widget.isConnected) paintCartState(widget, cart);
      });
    });
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  function announceCartAdd(widget, lines) {
    markAdded(widget);
    if (lines && lines.size) {
      const merged = new Map(widget.rbbCartLines || []);
      lines.forEach((line, key) => merged.set(key, line));
      widget.rbbCartLines = merged;
      widget.dataset.rbbInCart = String(merged.size);
      let items = 0;
      merged.forEach((line) => {
        items += line.quantity || 0;
      });
      widget.dataset.rbbCartItems = String(items);
      paintCartTags(widget);
      paintRows(widget);
      paintCartMode(widget);
      paintProgress(widget);
      paintAddAll(widget);
    }
    fetchCart(true).then((cart) => {
      const pubsub = window.theme && window.theme.pubsub;
      if (cart && pubsub && pubsub.publish && pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate) {
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'rebuy-bundle', cart });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      if (widget.isConnected) paintCartState(widget, cart);
    });
  }

  function watchCartAdds() {
    document.addEventListener('click', (event) => {
      const cta = event.target.closest('.product__info .rebuy-bundle-builder .rebuy-bundle-builder__cta-container button.rebuy-button');
      if (!cta || cta.disabled) return;
      const widget = cta.closest('.rebuy-bundle-builder');
      if (widget && selectedCount(widget) > 0) waitForCartAdd(widget);
    }, true);

    document.addEventListener('rebuy:cart.add', () => finishCartAdd(true));
    document.addEventListener('rebuy:cart.change', () => syncCartState(true));
    document.addEventListener('cart:refresh', () => syncCartState(true));

    const pubsub = window.theme && window.theme.pubsub;
    if (pubsub && typeof pubsub.subscribe === 'function' && pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate) {
      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, (data) => {
        if (data && data.source === 'rebuy-bundle') return;
        syncCartState(true);
      });
    }
  }

  function selectedCount(widget) {
    const node = widget.querySelector('.rebuy-bundle-builder__group-container-header-products_count');
    return node ? parseInt(node.textContent, 10) || 0 : 0;
  }

  function containerMax(widget) {
    const node = widget.querySelector('.rebuy-bundle-builder__group-container-header-container-length');
    return node ? parseInt(node.textContent, 10) || 0 : 0;
  }

  function waitFor(check, timeout) {
    return new Promise((resolve) => {
      const started = performance.now();
      const tick = () => {
        if (check()) return resolve(true);
        if (performance.now() - started > timeout) return resolve(false);
        window.setTimeout(tick, 60);
      };
      tick();
    });
  }

  async function addAll(widget, button) {
    if (button.dataset.rbbBusy) return;
    if (button.classList.contains('is-done')) {
      openCartDrawer();
      return;
    }
    button.dataset.rbbBusy = 'true';
    button.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');
    setText(button.querySelector('.rbb-add-all__main'), TEXT.addAllBusy);

    const max = containerMax(widget) || Infinity;
    let guard = 0;
    while (selectedCount(widget) < max && guard < 8) {
      const block = Array.from(widget.querySelectorAll('.rebuy-product-block')).find((item) => !item.classList.contains('rbb-in-cart') && !item.querySelector('.rebuy-bundle-builder__item-quantity-widget'));
      const add = block && block.querySelector('button.rebuy-button');
      if (!add) break;
      const before = selectedCount(widget);
      add.click();
      await waitFor(() => selectedCount(widget) > before, 2500);
      guard += 1;
    }

    const cta = widget.querySelector('.rebuy-bundle-builder__cta-container button.rebuy-button');
    if (cta && !cta.disabled && selectedCount(widget) > 0) {
      const confirmed = waitForCartAdd(widget);
      cta.click();
      await confirmed;
    }

    delete button.dataset.rbbBusy;
    button.classList.remove('is-busy');
    button.removeAttribute('aria-busy');
    paintAddAll(widget);
  }

  function paintAddAll(widget) {
    if (!inlineHost(widget)) return;
    const action = widget.querySelector('.rebuy-bundle-builder__group-container-action');
    if (!action) return;

    let button = action.querySelector(':scope > .rbb-add-all');
    const total = widget.querySelectorAll('.rebuy-product-block').length;
    const free = widget.querySelectorAll('.rebuy-product-block:not(.rbb-in-cart)').length;
    const max = containerMax(widget) || total;
    const done = total > 0 && free === 0;
    const target = Math.min(done ? total : free, max);

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'rbb-add-all';
      const main = document.createElement('span');
      main.className = 'rbb-add-all__main';
      const sub = document.createElement('span');
      sub.className = 'rbb-add-all__sub';
      button.append(main, sub);
      button.addEventListener('click', () => addAll(widget, button));
      action.insertAdjacentElement('afterbegin', button);
    }

    if (button.dataset.rbbBusy) return;

    const hidden = total < 2;
    if (button.hidden !== hidden) button.hidden = hidden;
    if (hidden) return;

    if (button.classList.contains('is-done') !== done) button.classList.toggle('is-done', done);
    const pressed = done ? 'true' : 'false';
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);

    if (done) {
      setText(button.querySelector('.rbb-add-all__main'), TEXT.addAll(total));
      setText(button.querySelector('.rbb-add-all__sub'), TEXT.addAllDone);
      return;
    }

    const tier = readTiers(widget).filter((item) => item.value && item.count <= target).pop();
    setText(button.querySelector('.rbb-add-all__main'), free < total ? TEXT.addRest(target) : TEXT.addAll(target));
    setText(button.querySelector('.rbb-add-all__sub'), TEXT.addAllSub(tier ? tidyPercent(tier.value) : ''));
  }

  let zoomMedia = null;

  function zoomSource(src) {
    return src.replace(/_(\d+)x(\d+)(\.[a-z]+)(\?|$)/i, '_900x900$3$4');
  }

  function upgradeImage(image) {
    const current = image.currentSrc || image.src;
    if (!current) return;
    const source = zoomSource(current);
    if (source === current || image.dataset.rbbHi === source) return;

    image.dataset.rbbHi = source;
    const probe = new Image();
    probe.onload = () => {
      if (image.dataset.rbbHi !== source) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
    };
    probe.onerror = () => {
      if (image.dataset.rbbHi === source) delete image.dataset.rbbHi;
    };
    probe.src = source;
  }

  function aimZoom(media, event) {
    const image = media.querySelector('img');
    if (!image) return;
    const rect = media.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
    image.style.transformOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
  }

  function startZoom(media, event) {
    if (!window.matchMedia(ZOOM_QUERY).matches) return;
    const image = media.querySelector('img');
    if (!image) return;
    zoomMedia = media;
    upgradeImage(image);
    aimZoom(media, event);
    media.classList.add('rbb-zooming');
  }

  function stopZoom() {
    if (!zoomMedia) return;
    zoomMedia.classList.remove('rbb-zooming');
    zoomMedia = null;
  }

  function watchZoom() {
    document.addEventListener('mouseover', (event) => {
      const media = event.target.closest(MEDIA_SELECTOR);
      if (!media || media === zoomMedia) return;
      stopZoom();
      startZoom(media, event);
    });
    document.addEventListener('mousemove', (event) => {
      if (!zoomMedia) return;
      if (!zoomMedia.isConnected) {
        zoomMedia = null;
        return;
      }
      aimZoom(zoomMedia, event);
    });
    document.addEventListener('mouseout', (event) => {
      if (!zoomMedia) return;
      if (event.relatedTarget && zoomMedia.contains(event.relatedTarget)) return;
      if (event.target.closest(MEDIA_SELECTOR) === zoomMedia) stopZoom();
    });
    window.addEventListener('scroll', stopZoom, { passive: true });
  }

  function run() {
    syncInline();
    document.querySelectorAll(SELECT_SELECTOR).forEach(enhance);
    document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      widget.querySelectorAll('.rebuy-product-block').forEach(decorate);
    });
    document.querySelectorAll('.rebuy-bundle-builder').forEach((widget) => {
      watchPanel(widget);
      observeWidget(widget);
      paintProgress(widget);
      paintSavings(widget);
      paintHolders(widget);
      if (inlineHost(widget)) {
        paintLayout(widget);
        paintCartTags(widget);
        paintRows(widget);
        paintCartMode(widget);
        paintAddAll(widget);
        paintStrip(widget);
        if (!widget.dataset.rbbCartSynced) {
          widget.dataset.rbbCartSynced = 'true';
          syncCartState(false);
        }
      }
    });
    markRowPositions();
    if (document.querySelector('.rebuy-bundle-builder__group-container')) primed = true;
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      run();
    });
  });

  function observeWidget(widget) {
    if (widgetsWatched.has(widget)) return;
    widgetsWatched.add(widget);
    observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    run();
    watchZoom();
    watchCartAdds();

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.rebuy-bundle-builder .rebuy-product-block button.rebuy-button');
      if (button && !button.disabled) flyToPanel(button);
    }, true);

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('.rbb-strip-arrow');
      if (!arrow || arrow.disabled) return;
      const step = arrow.closest('.rebuy-bundle-builder__step-container');
      if (step) slideStrip(step, arrow.dataset.rbbDirection === 'prev' ? -1 : 1);
    });

    document.addEventListener('click', (event) => {
      const block = event.target.closest(ROW_SELECTOR);
      if (!block || event.defaultPrevented) return;
      if (event.target.closest(ROW_CONTROLS)) return;
      event.preventDefault();
      toggleRow(block);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    let resizeQueued = false;
    window.addEventListener('resize', () => {
      if (resizeQueued) return;
      resizeQueued = true;
      window.requestAnimationFrame(() => {
        resizeQueued = false;
        markRowPositions();
        syncStrips();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
